import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  topRecognitionRecipientsLabel: {
    defaultMessage: 'Top recognition recipients',
    id: 'yAnRz2',
  },
  topRecognitionRecipientsDescription: {
    defaultMessage:
      'Please create a table listing the top 10 recognition recipients by the number of recognition posts received and the total points awarded to them, sorted by posts, for the last 3 months.',
    id: 'hhbJJz',
  },
  crossDepartmentalRecognitionLabel: {
    defaultMessage: 'Cross-departmental recognition',
    id: 'ab4fpm',
  },
  crossDepartmentalRecognitionDescription: {
    defaultMessage:
      'Create a heat map that visualizes the frequency of recognition posts between departments over the last 3 months. Identify the top 10 most active departments on the platform based on their total recognition activity (both sending and receiving). Use these departments for both axes of the heat map, with one axis representing the sending department and the other the receiving department. Fill the heat map with the frequency of recognition posts exchanged between these departments.',
    id: 'VPGN21',
  },
  recognitionReceivedByDepartmentLabel: {
    defaultMessage: 'Recognition received by department',
    id: 'TEN6Yo',
  },
  recognitionReceivedByDepartmentDescription: {
    defaultMessage:
      'Create a dual-axis bar chart displaying the total number of recognition posts and points received by each department in the last 3 months, sorted in descending order. Show only the top 10 departments.',
    id: 'tM3spT',
  },
  recognitionReceivedByLocationLabel: {
    defaultMessage: 'Recognition received by location',
    id: 'tzUVJt',
  },
  recognitionReceivedByLocationDescription: {
    defaultMessage:
      'Produce a dual-axis bar chart that compares the total recognition posts and points received across different locations in the last 3 months, with locations sorted by the number of posts. Show only the top 10 locations',
    id: 'O2vTC6',
  },
  recognitionReceivedByTeamLabel: {
    defaultMessage: 'Recognition received by team',
    id: '9Znsyd',
  },
  recognitionReceivedByTeamDescription: {
    defaultMessage:
      "Generate a dual-axis bar chart displaying the number of recognition posts and the total recognition points received by each team in the last 3 months. Teams should be organized by their manager's name and arranged in descending order based on the number of posts received. Show only the top 10 teams.",
    id: 'S6fANX',
  },
  teamRecognitionReceivedLabel: {
    defaultMessage: 'Team recognition received',
    id: 'f6D9kU',
  },
  teamRecognitionReceivedDescription: {
    defaultMessage:
      'Create a bar chart of recognition received by my team in the last 3 months, detailing each member’s total recognition posts received, sorted by posts received.',
    id: 'MkAbix',
  },
  whoNeedsRecognitionLabel: {
    defaultMessage: 'Who needs recognition?',
    id: 'bTy8Wi',
  },
  whoNeedsRecognitionDescription: {
    defaultMessage:
      'Help me identify team members who have not received recognition recently, listing Name, Date Last Recognized, and Days Since Last Recognized, sorted by the longest duration without recognition.',
    id: 'G/cdPK',
  },
  whoIsMyTeamRecognizingLabel: {
    defaultMessage: 'Who is my team recognizing?',
    id: 'FM/2Fk',
  },
  whoIsMyTeamRecognizingDescription: {
    defaultMessage:
      'Show a breakdown of the departments my team has recognized the most in terms of posts, visualized in a bar chart, sorted by the number of recognitions.',
    id: 'cCsjda',
  },
  overviewOfFlowsLabel: {
    defaultMessage: 'Overview of flows',
    id: 'c44iUp',
  },
  overviewOfFlowsDescription: {
    defaultMessage:
      'List all flows within the workspace, including Flow Name, Flow Owner, Creation Date, and Number of Posts since creation, sorted by Creation Date. Please provide a downloadable CSV.',
    id: 'VIxvdW',
  },
  topPerformingFlowsLabel: {
    defaultMessage: 'Top performing flows',
    id: 'tQW547',
  },
  topPerformingFlowsDescription: {
    defaultMessage:
      'Generate a table of the top 10 flows ranked by activity in the last 3 months, including Flow Name, Flow Creator, Creation Date, number of Posts, Comments, and Reactions since creation.',
    id: '5gKSHy',
  },
  flowEngagementByDepartmentLabel: {
    defaultMessage: 'Flow engagement by department',
    id: 'q0+5ZP',
  },
  flowEngagementByDepartmentDescription: {
    defaultMessage:
      'Create a bar chart showing the number of posts created by each department, with departments sorted by the number of posts. Show only the top 10 departments.',
    id: 'LcpG61',
  },
  flowEngagementByTeamLabel: {
    defaultMessage: 'Flow engagement by team',
    id: 'oHByMy',
  },
  flowEngagementByTeamDescription: {
    defaultMessage:
      "Display a bar chart comparing the total number of posts created by team. Teams should be organized by their manager's name, with teams ranked by their posting activity. Show only the top 10 teams.",
    id: 'A1IIx+',
  },
  flowEngagementByEmployeeLabel: {
    defaultMessage: 'Flow engagement by employee',
    id: 'eg2Sh6',
  },
  flowEngagementByEmployeeDescription: {
    defaultMessage:
      'Produce a ranked list of the top 20 most active employees in flows, sorted by posts created in the last 3 months. Include a count of comments and reactions. Please show the full table, all 20 employees.',
    id: 'r4Z6w9',
  },
  overviewOfMyFlowsLabel: {
    defaultMessage: 'Overview of my flows',
    id: '72GM+V',
  },
  overviewOfMyFlowsDescription: {
    defaultMessage:
      'List all flows owned by me, including Flow Name, Creation Date, and Number of Posts since creation, sorted by Creation Date.',
    id: 'AtdLJn',
  },
  flowEngagementByTeamMemberLabel: {
    defaultMessage: 'Flow engagement by team member',
    id: '2Zo+OV',
  },
  flowEngagementByTeamMemberDescription: {
    defaultMessage:
      'Generate a ranked list of my team members based on their engagement in flows I own, detailing posts made, sorted by the number of posts.',
    id: 'l+O9Od',
  },
  upcomingAnniversariesLabel: {
    defaultMessage: 'Upcoming anniversaries',
    id: 'OmjhK7',
  },
  upcomingAnniversariesDescription: {
    defaultMessage:
      "List all of my team members' anniversaries happening in the next 30 days, including Name, Department, and Date of Anniversary, sorted by date.",
    id: 'NvPix9',
  },
  allUpcomingAnniversariesDescription: {
    defaultMessage:
      'List all employee anniversaries happening in the next 30 days, including Name, Department, and Date of Anniversary, sorted by date.',
    id: '6XuT+u',
  },
  upcomingBirthdaysLabel: {
    defaultMessage: 'Upcoming birthdays',
    id: 'bjgIFc',
  },
  upcomingBirthdaysDescription: {
    defaultMessage:
      'Generate a list of my team members with birthdays in the next 30 days, showing Employee Name, Department, and Birthday, ordered by date.',
    id: '4JqgfG',
  },
  allUpcomingBirthdaysDescription: {
    defaultMessage:
      'Generate a list of employees with birthdays in the next 30 days, showing Employee Name, Department, and Birthday, ordered by date.',
    id: 'STjQsW',
  },
});

export function useSuggestedChatQuestions() {
  const { formatMessage } = useIntl();

  return [
    {
      role: 'admin',
      category: 'recognition',
      question: formatMessage(messages.topRecognitionRecipientsLabel),
      text: formatMessage(messages.topRecognitionRecipientsDescription),
    },
    {
      role: 'admin',
      category: 'recognition',
      question: formatMessage(messages.crossDepartmentalRecognitionLabel),
      text: formatMessage(messages.crossDepartmentalRecognitionDescription),
    },
    {
      role: 'admin',
      category: 'recognition',
      question: formatMessage(messages.recognitionReceivedByDepartmentLabel),
      text: formatMessage(messages.recognitionReceivedByDepartmentDescription),
    },
    {
      role: 'admin',
      category: 'recognition',
      question: formatMessage(messages.recognitionReceivedByLocationLabel),
      text: formatMessage(messages.recognitionReceivedByLocationDescription),
    },
    {
      role: 'admin',
      category: 'recognition',
      question: formatMessage(messages.recognitionReceivedByTeamLabel),
      text: formatMessage(messages.recognitionReceivedByTeamDescription),
    },
    {
      role: 'manager',
      category: 'recognition',
      question: formatMessage(messages.teamRecognitionReceivedLabel),
      text: formatMessage(messages.teamRecognitionReceivedDescription),
    },
    {
      role: 'manager',
      category: 'recognition',
      question: formatMessage(messages.whoNeedsRecognitionLabel),
      text: formatMessage(messages.whoNeedsRecognitionDescription),
    },
    {
      role: 'manager',
      category: 'recognition',
      question: formatMessage(messages.whoIsMyTeamRecognizingLabel),
      text: formatMessage(messages.whoIsMyTeamRecognizingDescription),
    },
    {
      role: 'admin',
      category: 'flows',
      question: formatMessage(messages.overviewOfFlowsLabel),
      text: formatMessage(messages.overviewOfFlowsDescription),
    },
    {
      role: 'admin',
      category: 'flows',
      question: formatMessage(messages.topPerformingFlowsLabel),
      text: formatMessage(messages.topPerformingFlowsDescription),
    },
    {
      role: 'admin',
      category: 'flows',
      question: formatMessage(messages.flowEngagementByDepartmentLabel),
      text: formatMessage(messages.flowEngagementByDepartmentDescription),
    },
    {
      role: 'admin',
      category: 'flows',
      question: formatMessage(messages.flowEngagementByTeamLabel),
      text: formatMessage(messages.flowEngagementByTeamDescription),
    },
    {
      role: 'admin',
      category: 'flows',
      question: formatMessage(messages.flowEngagementByEmployeeLabel),
      text: formatMessage(messages.flowEngagementByEmployeeDescription),
    },
    {
      role: 'manager',
      category: 'flows',
      question: formatMessage(messages.overviewOfMyFlowsLabel),
      text: formatMessage(messages.overviewOfMyFlowsDescription),
    },
    {
      role: 'manager',
      category: 'flows',
      question: formatMessage(messages.flowEngagementByTeamMemberLabel),
      text: formatMessage(messages.flowEngagementByTeamMemberDescription),
    },
    {
      role: 'admin',
      category: 'users',
      question: formatMessage(messages.upcomingAnniversariesLabel),
      text: formatMessage(messages.allUpcomingAnniversariesDescription),
    },
    {
      role: 'admin',
      category: 'users',
      question: formatMessage(messages.upcomingBirthdaysLabel),
      text: formatMessage(messages.allUpcomingBirthdaysDescription),
    },
    {
      role: 'manager',
      category: 'users',
      question: formatMessage(messages.upcomingAnniversariesLabel),
      text: formatMessage(messages.upcomingAnniversariesDescription),
    },
    {
      role: 'manager',
      category: 'users',
      question: formatMessage(messages.upcomingBirthdaysLabel),
      text: formatMessage(messages.upcomingBirthdaysDescription),
    },
  ];
}
